import {
  Box,
  Button,
  Checkbox,
  HStack,
  Input,
  Text,
  VStack,
} from '@chakra-ui/react'
import { format, subMonths } from 'date-fns'
import React, { useCallback, useMemo, useState } from 'react'
import { REPOSITORY } from '../../../../api/repository/Repository'
import CustomDatePicker from '../../../../components/CustomDatePicker/CustomDatePicker'
import { useLoadingContext } from '../../../../utils/hooks/Context/LoadingContext'
import { useRequestStatusContext } from '../../../../utils/hooks/Context/RequestStatusContext'

export default function RefillReport() {
  const defaultFrom = useMemo(() => subMonths(new Date(), 1), [])
  const defaultTo = useMemo(() => new Date(), [])

  const [filterData, setFilterData] = useState({
    dDesde: format(defaultFrom, 'dd-MM-yyyy'),
    dHasta: format(defaultTo, 'dd-MM-yyyy'),
    sFactura: undefined,
    sRecarga: undefined,
  })

  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const [onlyBilled, setOnlyBilled] = useState(false)

  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()

  const hasOptional =
    (filterData.sFactura || '').trim() !== '' ||
    (filterData.sRecarga || '').trim() !== ''

  const handleToogleCheckBill = () => {
    setOnlyBilled((prevState) => !prevState)
  }

  const handleGetReport = async () => {
    const dDesdeToSend = hasOptional ? '01-01-2012' : filterData.dDesde
    const dHastaToSend = hasOptional
      ? format(new Date(), 'dd-MM-yyyy')
      : filterData.dHasta

    if (!dDesdeToSend || !dHastaToSend) {
      handleSetTitle('Faltan fechas', 400)
      handleChangeBody(
        <Button variant="primary" onClick={handleClose}>
          Continuar
        </Button>,
      )
      handleOpen()
      return
    }

    handleOpenLoading()

    await REPOSITORY.wsEmpresa.reports
      .refillsReport(
        dDesdeToSend,
        dHastaToSend,
        onlyBilled,
        filterData.sFactura,
        filterData.sRecarga,
        {
          'Content-Type': 'blob',
        },
      )
      .then((response) => {
        const url = URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `ReporteDetalleRecargaSucursal.xlsx`)
        document.body.appendChild(link)
        link.click()
        handleCLoseLoading()
        handleSetTitle('Reporte descargado con exito', 200)
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            Continuar
          </Button>,
        )
        handleOpen()
      })
      .catch((error) => {
        handleCLoseLoading()
        handleSetTitle(
          'No se pudo crear el reporte. Intente alargando el rango de fechas, si el error persiste, contacte a soporte',
          error.response?.status,
        )
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
          </Button>,
        )
        handleOpen()
      })

    handleCLoseLoading()
  }

  const handleChangeFrom = useCallback((date) => {
    setFilterData((prevState) => ({
      ...prevState,
      dDesde: date ? format(date, 'dd-MM-yyyy') : '',
    }))
  }, [])

  const handleChangeTo = useCallback((date) => {
    setFilterData((prevState) => ({
      ...prevState,
      dHasta: date ? format(date, 'dd-MM-yyyy') : '',
    }))
  }, [])

  const handleChangeInvoice = useCallback((e) => {
    const v = (e.target.value || '').trim()
    setFilterData((prevState) => ({
      ...prevState,
      sFactura: v || undefined,
    }))
  }, [])

  const handleChangeRefill = useCallback((e) => {
    const v = (e.target.value || '').trim()
    setFilterData((prevState) => ({
      ...prevState,
      sRecarga: v || undefined,
    }))
  }, [])

  return (
    <VStack alignItems="flex-start">
      <HStack alignItems="flex-end" wrap="wrap">
        <VStack alignItems="flex-start">
          <Text variant="subtitle2">Desde</Text>
          <Box
            border="1px solid #D7D7D7"
            maxW="150px"
            minW="120px"
            pointerEvents={hasOptional ? 'none' : 'auto'}
            opacity={hasOptional ? 0.6 : 1}
          >
            <CustomDatePicker
              maxDate={new Date()}
              defaultValue={defaultFrom}
              onChange={handleChangeFrom}
              placeholder="dd/mm/aaaa"
            />
          </Box>
        </VStack>

        <VStack alignItems="flex-start">
          <Text variant="subtitle2">Hasta</Text>
          <Box
            border="1px solid #D7D7D7"
            maxW="150px"
            minW="100px"
            w="120px"
            pointerEvents={hasOptional ? 'none' : 'auto'}
            opacity={hasOptional ? 0.6 : 1}
          >
            <CustomDatePicker
              maxDate={new Date()}
              defaultValue={defaultTo}
              onChange={handleChangeTo}
              placeholder="dd/mm/aaaa"
            />
          </Box>
        </VStack>

        <VStack alignItems="flex-start">
          <Checkbox onChange={handleToogleCheckBill} checked={onlyBilled}>
            Solo recargas por facturar
          </Checkbox>
        </VStack>

        <VStack alignItems="flex-start">
          <Text variant="subtitle2">Numero Factura (Opcional)</Text>
          <Input
            placeholder="Ingrese numero de factura"
            onChange={handleChangeInvoice}
            maxW="200px"
          />
        </VStack>

        <VStack alignItems="flex-start">
          <Text variant="subtitle2">Numero Recarga (Opcional)</Text>
          <Input
            placeholder="Ingrese numero de recarga"
            onChange={handleChangeRefill}
            maxW="200px"
          />
        </VStack>

        <VStack paddingStart={5}>
          <Button borderRadius={10} onClick={handleGetReport}>
            Buscar
          </Button>
        </VStack>
      </HStack>
    </VStack>
  )
}
